import React from 'react'
import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'
import AnimatedNumber from '../../../../components/AnimatedNumber'
import { formatPrice } from '../../../../utils/formatters'
import { CARD_CLASS, ProgressBar, PumpkinIcon, WitchPortrait } from './shared'

/**
 * Общая цель всех банд — накормить ведьму. Полоска только пока не накормлена
 * (pct: null при fed), после — плашка «ведьма накормлена».
 */
const WitchCard = ({ witch, witchPrize }) => {
  const { t } = useTranslation()
  if (!witch) return null
  const { pumpkins, goal, fed, pct } = witch

  return (
    <section className={`${CARD_CLASS} relative overflow-hidden p-5`}>
      <div
        className={`pointer-events-none absolute -right-14 -top-14 h-44 w-44 rounded-full blur-3xl ${fed ? 'bg-lime-400/20' : 'bg-violet-600/20'}`}
        aria-hidden="true"
      />

      <div className="relative flex items-center gap-4">
        <WitchPortrait size={76} fed={fed} />
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-wide text-lime-300">
            {t('halloweenEvent.witch.title')}
          </p>
          <p className="mt-0.5 text-lg font-black leading-tight text-white">
            {fed ? t('halloweenEvent.witch.fedTitle') : t('halloweenEvent.witch.hungry')}
          </p>
          <p className="mt-1 flex flex-wrap items-center gap-x-1.5">
            <PumpkinIcon size={18} glow />
            <span className="hev-toxic-text text-2xl font-black tabular-nums">
              <AnimatedNumber value={pumpkins} />
            </span>
            <span className="text-sm text-text-secondary">
              {t('halloweenEvent.witch.of', { goal: formatPrice(goal) })}
            </span>
          </p>
        </div>
      </div>

      {fed ? (
        <div className="relative mt-4 flex items-center gap-2 rounded-xl border border-lime-400/30 bg-lime-400/10 px-3 py-2.5">
          <Sparkles size={16} className="shrink-0 text-lime-300" />
          <p className="text-sm font-semibold text-lime-100">
            {witchPrize
              ? t('halloweenEvent.witch.fedText', { count: witchPrize.count, amount: formatPrice(witchPrize.amount) })
              : t('halloweenEvent.witch.fedTitle')}
          </p>
        </div>
      ) : (
        <div className="relative mt-4">
          <div className="mb-1.5 flex items-center justify-end text-xs font-bold tabular-nums text-lime-200">
            {pct ?? 0}%
          </div>
          <ProgressBar pct={pct} tone="toxic" />
          {witchPrize && (
            <p className="mt-3 text-xs leading-relaxed text-text-secondary">
              {t('halloweenEvent.witch.hint', {
                goal: formatPrice(goal),
                count: witchPrize.count,
                amount: formatPrice(witchPrize.amount)
              })}
            </p>
          )}
        </div>
      )}
    </section>
  )
}

export default WitchCard
